import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";


@Component({
    selector: 'ea-import-config-object-component',
    templateUrl: 'ea-import-config-object.component.html',
    standalone: false
})
export class EaImportConfigObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    onObjectChanged() {
        const dto = this.dto as any;
        if (dto?.targetObjectType) {
            this.setPageTitle(`Import Config: ${dto.targetObjectType}`);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
